import React from 'react';
import { parseOptions } from '../../pages/Events/tabs/ServicesTab';

const inpSt: React.CSSProperties = {
  background: 'var(--glass-bg-card)', border: '1px solid rgba(255,255,255,0.10)',
  borderRadius: 'var(--radius-card)', color: 'var(--color-text)',
  fontSize: 'var(--text-sm)', padding: '0.5rem 0.75rem', outline: 'none', width: '100%',
};
const selSt: React.CSSProperties = { ...inpSt, cursor: 'pointer' };

export interface AttributeDef {
  key: string;
  attributeType: string;
  defaultValue?: string | null;
  options?: string | null;
  unit?: string | null;
  isRequired?: boolean;
}

export function AttributeEditor({
  attrs, values, onChange,
}: {
  attrs: AttributeDef[];
  values: Record<string, unknown>;
  onChange: (v: Record<string, unknown>) => void;
}) {
  const active = attrs.filter(a => a.key);
  if (active.length === 0) return null;

  return (
    <div style={{ padding: '0.625rem', background: 'var(--color-surface-3)', borderRadius: 'var(--radius-card)', border: '1px dashed rgba(255,255,255,0.10)' }}>
      <p style={{ fontSize: 'var(--text-xs)', fontWeight: 600, color: 'var(--color-text-faint)', marginBottom: '0.5rem' }}>Attributi prodotto</p>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(130px, 1fr))', gap: '0.5rem' }}>
        {active.map(attr => {
          const val = values[attr.key] ?? attr.defaultValue ?? '';
          const upd = (v: unknown) => onChange({ ...values, [attr.key]: v });
          return (
            <div key={attr.key} style={{ display: 'flex', flexDirection: 'column', gap: '0.2rem' }}>
              <label style={{ fontSize: 'var(--text-xs)', color: 'var(--color-text-muted)', fontWeight: 500 }}>
                {attr.key}{attr.isRequired ? ' *' : ''}{attr.unit ? ` (${attr.unit})` : ''}
              </label>
              {attr.attributeType === 'SELECT' ? (
                <select value={String(val)} onChange={e => upd(e.target.value)} style={selSt}>
                  <option value="">— scegli —</option>
                  {parseOptions(attr.options).map((o: string) => <option key={o} value={o}>{o}</option>)}
                </select>
              ) : attr.attributeType === 'BOOLEAN' ? (
                <select
                  value={val === true || val === 'true' ? 'true' : val === false || val === 'false' ? 'false' : ''}
                  onChange={e => { if (e.target.value !== '') upd(e.target.value === 'true'); }}
                  style={selSt}
                >
                  <option value="">— scegli —</option>
                  <option value="true">Si</option>
                  <option value="false">No</option>
                </select>
              ) : attr.attributeType === 'NUMBER' ? (
                <input type="number" value={String(val)} onChange={e => upd(Number(e.target.value))} style={inpSt} />
              ) : (
                <input type="text" value={String(val)} onChange={e => upd(e.target.value)} style={inpSt} placeholder={attr.defaultValue ?? ''} />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
